// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

import { prepareWaitingApprovals, requestTypeLabel } from "../../../company/request-center/request-center.functions";

export class Controller {
    /** @ngInject */
    constructor(RequestCenterService, ShowNoteModal, ConfirmDeleteModal, $state) {
        this.RequestCenterService = RequestCenterService;
        this.ShowNoteModal = ShowNoteModal;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.$state = $state;
    }

    $onInit() {
    }

    showNote(requestDto){
        this.ShowNoteModal('Note', requestDto.note);
    }

    getWaitingApprovals(requestDto) {
        return prepareWaitingApprovals(requestDto);
    }

    getRequestTypeLabel(requestDto) {
        return requestTypeLabel(requestDto.type);
    }
    
    displayDeleteButton(requestDto) {
        return requestDto.status == 'PENDING';
    }

    deleteRequest(requestDto) {
        this.ConfirmDeleteModal('Are you sure you want to delete this request')
            .then(() => {
                this.RequestCenterService.deleteRequest(requestDto.id)
                    .then(() => this.$state.go('.', {}, {reload: '.'}))
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/request-center/requests/access-requests.controller.js